import React from "react";
import I18n from "../../../../base/i18n.js";

import { withStyles } from '@material-ui/styles';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";

import ButtonLink from "../../../../base/links/button_link.js";

import ListProjectsUseCase from "../../../../use_cases/admin/projects/projects/list_projects_use_case.js";
import { AdminProjectModel } from "../../../../models/projects/admin/project_model.js";

import TableView from "../../../../base/table/table_view.js"
import FormFields from "../../../../base/form/form_fields.js";

import BaseListPage from "../../base_list_page.js";

import Routes from "../../../routes.js";

const styles = theme => ({
});

class ProjectsListPage extends BaseListPage {

  processLoadedItems(items) {
    const { abilityInfos: { projects: { project: { admin: ability } } } = {} } = this.props;
    return items.map((item) => {
      return {
        ...item,
        itemLink: ability.read ? item.itemLink : undefined
      }
    });
  }

  headerContent() {
    const { classes } = this.props;
    return <React.Fragment>
      {
        this.allowedToCreateProjects() &&
        <ButtonLink className = { classes.button }
                  to = { Routes.project("new") } >
        { I18n.t("admin.projects.project.action.new") }
      </ButtonLink>
      }
    </React.Fragment>
  }

  filters() {
    const { filterData } = this.state;
    const { abilityInfos: { companies: { company: { admin: { index: allowToList } } } } = {} } = this.props;

    let filterFields = this.dataModel.listFilters().filter((filter) => {
      if(filter.name === "company" && !this.allowedToListCompanies()) {
        return false;
      }
      if(filter.name === "developer" && !this.allowedToListDevelopers()) {
        return false;
      }
      return true;
    });

    return <FormFields formFields = { filterFields } 
                       item = { filterData }
                       onItemChange = { this.onChangeFilterField } 
                       defaultWeight = { 2 } />
  }

  content() {
    const { items, filterData } = this.state;

    let columns = this.dataModel.listFields().filter((column) => {
      if(column.name === "company" && !this.allowedToListCompanies()) {
        return false;
      }
      return true;
    });
    
    return <TableView columns = { columns }
                      filterData = { filterData }
                      items = { items }
                      onChangeSort = { this.onChangeSort } />
  }

  allowedToCreateProjects = () => {
    const { abilityInfos: { projects: { project: { admin: { create: allowToCreate } } } } = {} } = this.props;
    return allowToCreate;
  }

  allowedToListCompanies = () => {
    const { abilityInfos: { companies: { company: { admin: { index: allowToList } } } } = {} } = this.props;
    return allowToList;
  }

  allowedToListDevelopers = () => {
    const { abilityInfos: { projects: { developer: { admin: { index: allowToList } } } } = {} } = this.props;
    return allowToList;
  }
  
}

ProjectsListPage.defaultProps = {
  dataModel: AdminProjectModel,
  listUseCase: ListProjectsUseCase
}

export default compose(
  withLocationSearchFilter,
  withShowToast, 
  withCurrentUser, 
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(ProjectsListPage);
